<template>
  <div>
    <div class="section-header" v-if="display">
      <span class="name">{{ title }}</span>
    </div>
    <div class="table-scroll">
      <table v-if="display">
        <thead>
          <tr class="header-row">
            <th>Dia de la semana</th>
            <th class="header-hour">Primer Turno</th>
            <th class="header-hour">Segundo Turno</th>
          </tr>
        </thead>
        <tbody>
          <tr
            ref="scheduleRow"
            v-for="(schedule, day) in mapScheduleCollection"
            :key="day"
          >
            <td v-if="schedule">{{ getDayName(day) }}</td>
            <td v-if="schedule">
              <div class="row-select">
                <v-select
                  :items="allowed_hours"
                  v-model="schedule.first.init"
                  @change="
                    saveScheduleHour($event, schedule, day, 'init', 'first')
                  "
                  label="Hora Inicio"
                  class="mx-md-3"
                  dense
                  style="width: 200px"
                  outlined
                  hide-details
                >
                  <template slot="selection" slot-scope="{ item }">
                    {{ formatTimeText(item) }}
                  </template>
                  <template slot="item" slot-scope="{ item }">
                    {{ formatTimeText(item) }}
                  </template>
                </v-select>
              </div>
              <div class="row-select mt-5">
                <v-select
                  :items="allowed_hours"
                  v-model="schedule.first.fin"
                  @change="
                    saveScheduleHour($event, schedule, day, 'fin', 'first')
                  "
                  label="Hora Fin"
                  class="mx-md-3"
                  style="width: 200px"
                  outlined
                  dense
                  hide-details
                >
                  <template slot="selection" slot-scope="{ item }">
                    {{ formatTimeText(item) }}
                  </template>
                  <template slot="item" slot-scope="{ item }">
                    {{ formatTimeText(item) }}
                  </template>
                </v-select>
              </div>
            </td>
            <td v-if="schedule">
              <div class="row-select">
                <v-select
                  :items="allowed_hours"
                  v-model="schedule.second.init"
                  @change="
                    saveScheduleHour($event, schedule, day, 'init', 'second')
                  "
                  label="Hora Inicio"
                  class="mx-md-3"
                  style="width: 200px"
                  outlined
                  dense
                  hide-details
                >
                  <template slot="selection" slot-scope="{ item }">
                    {{ formatTimeText(item) }}
                  </template>
                  <template slot="item" slot-scope="{ item }">
                    {{ formatTimeText(item) }}
                  </template>
                </v-select>
              </div>
              <div class="row-select mt-5">
                <v-select
                  :items="allowed_hours"
                  v-model="schedule.second.fin"
                  @change="
                    saveScheduleHour($event, schedule, day, 'fin', 'second')
                  "
                  label="Hora Fin"
                  class="mx-md-3"
                  style="width: 200px"
                  outlined
                  dense
                  hide-details
                >
                  <template slot="selection" slot-scope="{ item }">
                    {{ formatTimeText(item) }}
                  </template>
                  <template slot="item" slot-scope="{ item }">
                    {{ formatTimeText(item) }}
                  </template>
                </v-select>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
const DAYS = [
  {
    name: "Lunes",
    value: 1
  },
  {
    name: "Martes",
    value: 2
  },
  {
    name: "Miercoles",
    value: 3
  },
  {
    name: "Jueves",
    value: 4
  },
  {
    name: "Viernes",
    value: 5
  },
  {
    name: "Sabado",
    value: 6
  },
  {
    name: "Domingo",
    value: 0
  }
];

const ALLOWED_HOURS = [
  0,
  0.15,
  0.3,
  0.45,
  1,
  1.15,
  1.3,
  1.45,
  2,
  2.15,
  2.3,
  2.45,
  3,
  3.15,
  3.3,
  3.45,
  4,
  4.15,
  4.3,
  4.45,
  5,
  5.15,
  5.3,
  5.45,
  6,
  6.15,
  6.3,
  6.45,
  7,
  7.15,
  7.3,
  7.45,
  8,
  8.15,
  8.3,
  8.45,
  9,
  9.15,
  9.3,
  9.45,
  10,
  10.15,
  10.3,
  10.45,
  11,
  11.15,
  11.3,
  11.45,
  12,
  12.15,
  12.3,
  12.45,
  13,
  13.15,
  13.3,
  13.45,
  14,
  14.15,
  14.3,
  14.45,
  15,
  15.15,
  15.3,
  15.45,
  16,
  16.15,
  16.3,
  16.45,
  17,
  17.15,
  17.3,
  17.45,
  18,
  18.15,
  18.3,
  18.45,
  19,
  19.15,
  19.3,
  19.45,
  20,
  20.15,
  20.3,
  20.45,
  21,
  21.15,
  21.3,
  21.45,
  22,
  22.15,
  22.3,
  22.45,
  23,
  23.15,
  23.3,
  23.45,
  23.59
];

export default {
  name: "Schedule",
  props: {
    title: String,
    scheduleCollection: Array,
    display: Boolean,
    menuSchedule: Object
  },
  data() {
    return {
      allowed_hours: ALLOWED_HOURS
    };
  },
  computed: {
    mapScheduleCollection() {
      return this.scheduleCollection;
    }
  },
  methods: {
    getDayName(day) {
      return DAYS[day].name;
    },
    formatTimeText(time) {
      const parts = time.toString().split(".");
      let hour = time < 10 ? `0${parts[0]}` : `${parts[0]}`;

      if (parts[0] === "0") {
        hour = "00";
      }

      if (parts.length === 1) {
        return `${hour}:00 h.`;
      }

      let minutes = parts[1];
      if (parts[1] === "3") {
        minutes = "30";
      }

      return `${hour}:${minutes} h.`;
    },
    saveScheduleHour(event, schedule, day, range, shift) {
      console.log("menuSchedule", this.menuSchedule);

      if (this.menuSchedule && Object.keys(this.menuSchedule).length > 0) {
        this.$emit("saveSchedule", event, this.menuSchedule, day, range, shift);
      } else {
        this.$emit("saveSchedule", event, schedule, day, range, shift);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.table-scroll {
  max-width: 100%;
  overflow-x: auto;
}
</style>
